import React from "react";

interface OwnProps {
	image: string;
	title: string;
}

const Avatars = ({ image, title }: OwnProps) => (
	<div className="flex justify-center items-center flex-col text-white dark:text-white gap-4">
		<img className="w-32 rounded-full" src={image} alt={title} />
		<p className="text-white dark:text-white">{title}</p>
	</div>
);

export default Avatars;
